import { Link } from "react-router-dom";
import { getFeaturedArticles } from "@/mocks/articles";
import { getCategoryBySlug } from "@/mocks/categories";

export default function FeaturedArticles() {
  const featured = getFeaturedArticles();

  return (
    <section className="py-12 md:py-16 bg-background-100">
      <div className="px-4 md:px-6 max-w-6xl mx-auto">
        <div className="flex items-center justify-between mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-2">
              精选购票指南
            </h2>
            <p className="text-foreground-600 text-sm">编辑推荐的高质量购票攻略</p>
          </div>
          <Link
            to="/category/fifa-official"
            className="hidden sm:inline-flex items-center gap-1.5 text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors duration-200 whitespace-nowrap cursor-pointer"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {featured.map((article) => {
            const category = getCategoryBySlug(article.categorySlug);
            return (
              <Link
                key={article.id}
                to={`/article/${article.slug}`}
                className="group bg-background-50 rounded-lg overflow-hidden border border-background-200 hover:border-primary-200 transition-all duration-300 cursor-pointer flex flex-col"
              >
                <div className="relative h-48 md:h-56 overflow-hidden">
                  <img
                    src={article.coverImage}
                    alt={article.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                </div>
                <div className="p-5 flex flex-col flex-1">
                  <div className="flex items-center gap-3 mb-3">
                    {category && (
                      <span className="text-xs px-2.5 py-1 bg-secondary-100 text-secondary-700 rounded-full font-medium whitespace-nowrap">
                        {category.name}
                      </span>
                    )}
                    <span className="text-xs text-foreground-500 whitespace-nowrap">
                      {article.readTime} 分钟阅读
                    </span>
                  </div>
                  <h3 className="text-lg font-semibold text-foreground-900 mb-2 group-hover:text-primary-500 transition-colors duration-200 line-clamp-2">
                    {article.title}
                  </h3>
                  <p className="text-sm text-foreground-600 leading-relaxed mb-4 line-clamp-2">
                    {article.summary}
                  </p>
                  <div className="mt-auto flex items-center justify-between">
                    <span className="text-xs text-foreground-500 whitespace-nowrap">
                      {article.publishDate}
                    </span>
                    <span className="text-xs text-primary-500 font-medium whitespace-nowrap">
                      阅读全文 &rarr;
                    </span>
                  </div>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}